/* unplugin-vue-components disabled */import { render } from "./expenses.vue?vue&type=template&id=77f9adc0&scoped=true"
import script from "./expenses.vue?vue&type=script&lang=js"
export * from "./expenses.vue?vue&type=script&lang=js"

import "./expenses.vue?vue&type=style&index=0&id=77f9adc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77f9adc0"]])

export default __exports__